import { labels } from '@/app/constants/labels';
import type { Nullable } from '@/app/lib/types';
import InfoCircle from '@ixigo/icons/InfoCircle';
import { InlineAlert } from '@ixigo/iui/InlineAlert';
import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import type { EmiOption, SavedCardPaymentOption } from '../../domain/payment';
import SavedCardWithEMI from '../CardsSection/SavedCard/SavedCardWithEMI';
import EmiPlansTabs from './EmiPlansTabs';
import NoEmiPlans from './NoEmiPlans';

const EMIPage = ({
	savedCards,
	emiOptions,
	isExpanded,
	className,
}: {
	savedCards: SavedCardPaymentOption[];
	emiOptions: Nullable<EmiOption[]>;
	isExpanded?: boolean;
	className?: string;
}) => {
	if (emiOptions !== null && emiOptions.length === 0) {
		return isExpanded ? <EMIOfferError /> : <NoEmiPlans type="EMI" />;
	}
	return (
		<div className={clsx('bg-primary', className)}>
			{savedCards.length > 0 && (
				<>
					<div className="px-20">
						<Typography variant="body-md" fontWeight="bold" className="py-10">
							{labels.SAVED_CARDS_TEXT}
						</Typography>
						{savedCards?.map((card, index) => (
							<SavedCardWithEMI
								key={card.cardToken}
								card={card}
								className={clsx('py-15', index !== 0 ? 'border-t' : '')}
							/>
						))}
					</div>
					<div className="h-15 bg-tertiary" />
				</>
			)}
			<div className="px-20">
				{!isExpanded && (
					<Typography variant="body-md" fontWeight="bold" className="py-10">
						{labels.ALL_EMI_PLANS_TEXT}
					</Typography>
				)}
				<EmiPlansTabs isExpanded={isExpanded} />
			</div>
		</div>
	);
};

export default EMIPage;

const EMIOfferError = () => {
	return (
		<div className="py-20 px-20 bg-primary flex flex-col gap-10">
			<Typography variant="body-md" fontWeight="bold">
				EMI
			</Typography>
			<InlineAlert
				severity="critical"
				icon={<InfoCircle className="shrink-0" />}
				title={labels.NO_EMI_OFFER_AVAILABLE_TEXT}
			/>
		</div>
	);
};
